import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { NotificationsModule } from '../notifications/notifications.module';
import { EmailSettingsController } from './email-settings.controller';
import { EmailSettingsService } from './email-settings.service';
import { TemplatesController } from './templates.controller';
import { TemplatesService } from './templates.service';

@Module({
  imports: [NotificationsModule],
  controllers: [TemplatesController, EmailSettingsController],
  providers: [TemplatesService, EmailSettingsService, PrismaService],
})
export class TemplatesModule {}
